<template>
  <div>
    <HeaderCreditor header="เจ้าหนี้" :img_header="header_image" link_back="creditor/all"/>
    <MenuCreditor/>
    <PuInvoiceList/>
  </div>
</template>

<script>
import MenuCreditor from '@/components/admin/creditor/menucreditor/MenuCreditor.vue'
import PuInvoiceList from '@/components/admin/creditor/puinvoice/PuInvoiceList.vue'
import HeaderImage from "@/assets/creditor_1.png";
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";

export default {
  name:'puInvoice',
  components:{
    HeaderCreditor,
    MenuCreditor,
    PuInvoiceList,
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>
